import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import useDoLogin from '@src/hooks/use-do-login/use-do-login.hook'

const MailValidatedPage = () => {
  const { saveUtms } = useDoLogin({})
  const navigate = useNavigate()

  useEffect(() => {
    const handleRedirect = async () => {
      await saveUtms()
      const params = new URLSearchParams(window.location.search)
      navigate(`/login/register?${params.toString()}`, { replace: true })
    }

    handleRedirect()
  }, [navigate, saveUtms])

  return null
}

export default MailValidatedPage
